import { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BlogListPage } from "./pages/BlogListPage";
import { BlogDetailPage } from "./pages/BlogDetailPage";
import { MobileDrawer } from "./components/MobileDrawer";
import { ScrollToTop } from "./components/ScrollToTop";
import { getMainPageUrl, isSubdomain } from "./lib/subdomain";

// Nav items for mobile drawer on blog subdomain
const getBlogMobileNavItems = () => {
  const onBlogSubdomain = isSubdomain("blog");

  return [
    {
      label: "Home",
      href: onBlogSubdomain ? getMainPageUrl("/") : undefined,
      path: onBlogSubdomain ? undefined : "/",
      type: onBlogSubdomain ? ("external" as const) : ("route" as const),
    },
    {
      label: "Services",
      href: onBlogSubdomain ? getMainPageUrl("/services") : undefined,
      path: onBlogSubdomain ? undefined : "/services",
      id: "services",
      type: onBlogSubdomain ? ("external" as const) : ("route" as const),
    },
    {
      label: "Blog",
      path: "/",
      id: "blog",
      type: "route" as const,
    },
    {
      label: "About",
      href: onBlogSubdomain ? getMainPageUrl("/about") : undefined,
      path: onBlogSubdomain ? undefined : "/about",
      type: onBlogSubdomain ? ("external" as const) : ("route" as const),
    },
    {
      label: "Contact",
      id: "contact",
      href: onBlogSubdomain ? getMainPageUrl("/contact") : undefined,
      path: onBlogSubdomain ? undefined : "/contact",
      type: onBlogSubdomain ? ("external" as const) : ("route" as const),
    },
  ];
};

/**
 * Blog App - Rendered when on blog subdomain (blog.devdotcom.org)
 * This is a separate app structure for the blog subdomain
 */
function BlogApp() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const navItems = getBlogMobileNavItems();

  return (
    <BrowserRouter>
      <div className="min-h-screen bg-background font-sans antialiased">
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={
              <BlogListPage onMobileMenuOpen={() => setDrawerOpen(true)} />
            }
          />
          <Route
            path="/:slug"
            element={
              <BlogDetailPage onMobileMenuOpen={() => setDrawerOpen(true)} />
            }
          />
          {/* Catch-all redirect to blog home */}
          <Route
            path="*"
            element={
              <BlogListPage onMobileMenuOpen={() => setDrawerOpen(true)} />
            }
          />
        </Routes>
        <MobileDrawer
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          navItems={navItems}
        />
      </div>
    </BrowserRouter>
  );
}

export default BlogApp;
